module.exports = __webpack_public_path__ + "img/Deloitte-CaseAcademy-glowny-1080x108-clean (0-00-07-06)@2x.5503c4cb.png";